import Box from "@nexthink/apollo-components/lib/components/box/Box";
import styled from "styled-components";

export const StyledTooltipButtonContainer = styled(Box)({
  "& button:disabled": {
    pointerEvents: "none",
  },
});
